import { render } from "./FormattedMoney.vue?vue&type=template&id=0fe498a5"
import script from "./FormattedMoney.vue?vue&type=script&lang=js"
export * from "./FormattedMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__